import { jsx } from "react/jsx-runtime";
import "react";
function HiddenField(hiddenFieldProps) {
  return /* @__PURE__ */ jsx("input", { name: hiddenFieldProps.name, value: hiddenFieldProps.defaultValue, type: "hidden", "data-testid": "hidden-field" });
}
export {
  HiddenField as default
};
